// Design system constants matching Humblytics style guide

export const COLORS = {
  background: 'hsl(0 0% 100%)',
  foreground: 'hsl(0 0% 3.9%)',
  primary: 'hsl(0 0% 9%)',
  primaryOrange: '#FF7A00',
  muted: 'hsl(0 0% 96.1%)',
  border: 'hsl(0 0% 89.8%)',
  strokeLight: 'hsl(0 0% 89.8%)',
  strokeDark: 'hsl(0 0% 20%)',
  
  neutral: {
    50: 'hsl(0 0% 98%)',
    100: 'hsl(0 0% 96.1%)',
    200: 'hsl(0 0% 89.8%)',
    300: 'hsl(0 0% 83.1%)',
    500: 'hsl(0 0% 45.1%)',
    700: 'hsl(0 0% 25.1%)',
    900: 'hsl(0 0% 9%)',
  },
  
  destructive: '#dc2626',
  purple: '#7c3aed',
  green: '#10b981',
};

export const SHADOWS = {
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
};

export const RADIUS = '0.375rem';

export const FONT_FAMILIES = {
  sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  mono: "'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace",
};

export const Z_INDEX = {
  hoverActions: 2147483645,
  toolbar: 2147483647,
  overlay: 2147483648,
  widget: 2147483648,
  modal: 2147483649,
  debug: 2147483650,
};

export const BREAKPOINTS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};

export const TRANSITIONS = {
  fast: '0.15s ease-in-out',
  normal: '0.2s ease-in-out',
  slow: '0.3s ease-in-out',
};

export const EDITOR_CONFIG_DEFAULTS = {
  maxViewportWidthRatio: 0.98,
  maxViewportHeightRatio: 0.95,
  maxViewportAreaRatio: 0.85,
  strictMaxWidthRatio: 0.95,
  strictMaxHeightRatio: 0.85,
  maxChildElements: 20,
  maxBlockChildren: 8,
  minElementSize: 8,
  childPreferenceRatio: 0.9,
};

